module.exports = __webpack_public_path__ + "img/XharraNewLogo.72fbc0fd.svg";